import React from "react"
import "./RequestRow.css"

const RequestRow = (props) => {

    const class_name = props.rank == "Requête" ? "request-header" : "request-row-container"

    return(
        <>
            {!props.data && <div>
                <span>Requête invalide !</span>
            </div>}

            {props.data && <div className={class_name} key={props.data.uuidrequetes} onClick={() => {if (props.onRowClick) {props.onRowClick(props.data.uuidrequetes)}}}>
              <div className="col1">{props.header?props.rank:1 + props.total - props.rank}</div>
              <div className="col2">{props.data.time_stamp}</div>
              <div className="col3">{props.data.titre_etat_actuel}</div>
              <div className="col4">{props.data.beneficiaire}</div>
            </div>}
        </>
    )
}

export default RequestRow;
